import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRandom } from '@fortawesome/free-solid-svg-icons';

function StatusPill({ statusBadgeText, isConversionPractice }) {
    return (
        <>
            {statusBadgeText}

            {isConversionPractice && (
                <span>
                    &emsp;
                    <FontAwesomeIcon
                        title="This practice has a conversion offering"
                        icon={faRandom}
                    />
                </span>
            )}
        </>
    );
}

export default StatusPill;
